/* @ngInject */
export default function AppService($timeout, $window, ResponsiveBreakpoints) {
  const service = this;

  service.mobileToggle = {
    open: false
  };
  service.mql = $window.matchMedia(ResponsiveBreakpoints.smallTablet.mediaQuery);
  service.mql.addListener(_handleScreenSizeChangeForMobile);

  service._handleScreenSizeChangeForMobile = _handleScreenSizeChangeForMobile;
  service.toggleMobileMenu = toggleMobileMenu;

  // for handling going from phone to tablet mode, and the menu breaking
  function _handleScreenSizeChangeForMobile(mob) {
    if (mob.matches) {
      $timeout(() => {
        service.mobileToggle.open = false;
      });
    }
  }

  function toggleMobileMenu() {
    if (service.mobileToggle.open) {
      service.mobileToggle.open = false;
      service.mql.removeListener(_handleScreenSizeChangeForMobile);
    } else {
      service.mobileToggle.open = true;
      service.mql.addListener(_handleScreenSizeChangeForMobile);
    }
  }
}
